module.exports = __webpack_public_path__ + "img/categoryIcon.97adca5c.png";